const selectors = {
  countMetafield: '[data-pdp-variant-count-id]',
  form: '[data-purchase-form]',
  variantPrice: '[data-pdp-variant-price-id]',
};

const updateVariantInfo = (event) => {
  const { target } = event;
  const variantID = target.value;
  const form = target.closest(selectors.form);

  if (!form) return;

  console.log(variantID);

  const countText = form.querySelectorAll(selectors.countMetafield);
  const variantPrices = form.querySelectorAll(selectors.variantPrice);
  const selectedVariantCount = form.querySelector(`.count-id-${variantID}`);
  const selectedVariantPrices = form.querySelectorAll(`[data-pdp-variant-price-id="${variantID}"]`);

  if (countText) {
    Array.from(countText).forEach((count) => {
      count.classList.add('hide');
    });

    selectedVariantCount.classList.remove('hide');
  }

  if (variantPrices) {
    Array.from(variantPrices).forEach((price) => {
      price.classList.add('hide');
    });

    Array.from(selectedVariantPrices).forEach((price) => {
      price.classList.remove('hide');
    });
  }
};

export default updateVariantInfo;
